import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcEmptyList]'
})
export class EmptyListDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
